/**
 * FAQ section for the Universities/Institutions public page.
 * Self-contained — owns its own copy.
 */
import React from "react";
import { Pill, FAQItem, C } from "./primitives";

const FAQS = [
  {
    open: true,
    q: "How long does the pilot take?",
    a: "Our standard pilot is 90 days — including data import, team training, employer onboarding and your first live placement drive. Most campuses see a 20%+ uplift in placement velocity by month 3.",
  },
  {
    q: "Can we integrate with our ERP / LMS / SSO?",
    a: "Yes — we ship secure REST APIs and pre-built connectors for popular ERP, LMS and SSO systems (SAML, OIDC, Google Workspace, Microsoft Entra).",
  },
  {
    q: "Are placement reports NIRF / NAAC ready?",
    a: "Absolutely. One-click exports include outcome reports formatted for NIRF, NAAC and NBA cycles — saving weeks of manual prep.",
  },
  {
    q: "How is student data secured?",
    a: "Data is encrypted at rest (AES-256) and in transit (TLS 1.3). Every action is logged to a tamper-proof audit trail and access is gated through role-based controls.",
  },
  {
    q: "What's the commercial model?",
    a: "Annual subscription based on student cohort size. The 90-day pilot is risk-free — if outcomes don't move, you don't pay full.",
  },
];

export default function UniversityFAQ() {
  return (
    <section className="border-y" style={{ background: C.paper, borderColor: C.rule }}>
      <div className="max-w-4xl mx-auto px-6 py-16 md:py-20">
        <div className="text-center">
          <Pill color={C.navy}>FAQs</Pill>
          <h2
            className="font-display font-black text-3xl md:text-5xl mt-3 tracking-tight"
            style={{ color: C.navyDeep }}
          >
            Common questions, answered.
          </h2>
        </div>
        <div className="mt-10 space-y-3">
          {FAQS.map(({ q, a, open }) => (
            <FAQItem key={q} q={q} a={a} defaultOpen={!!open} />
          ))}
        </div>
      </div>
    </section>
  );
}
